<template>
  <div class="tariff_packet_item_info">
    <div class="content">
      <div class="header">
        <h5 class="title">
          {{ 'Информация по тарификации' }}
        </h5>
      </div>
      <div class="row">
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.tariffication.tariff_name" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.tariff_name')"
                    :readonly="true"/>
        </div>
        <div class="col-md-6">
          <fg-input v-model="status_text" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.tariffication_status')"
                    :readonly="true"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.tariffication.date_start" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.date_start')"
                    :readonly="true"/>
        </div>
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.tariffication.date_end" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.date_end')"
                    :readonly="true"/>
        </div>
      </div>

      <div class="header">
        <h5 class="title">
          Информация по пакету трафика № {{ tariff_packet_item.id }} за {{ tariff_packet_item.date }}
        </h5>
      </div>
      <div class="row">
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.date" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.date')"
                    :readonly="true"/>
        </div>
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.create_user_name" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.create_user_name')"
                    :readonly="true"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.traffic_status" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.traffic_status')"
                    :readonly="true"/>
        </div>
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.cost" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.cost')"
                    :readonly="true"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.name" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.name')"
                    :readonly="true"/>
        </div>
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.packet_name" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.packet_name')"
                    :readonly="true"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.client_name" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.client_name')"
                    :readonly="true"/>
        </div>

        <div class="col-md-6">
          <fg-input v-model="tariff_packet_item.region" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.region')"
                    :readonly="true"/>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <fg-input v-model="date_start" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.ts_create')"
                    :readonly="true"/>
        </div>
        <div class="col-md-6">
          <fg-input v-model="date_update" type="text"
                    :label="translate('traffic_packet_list.tariff_packet_item.ts_update')"
                    :readonly="true"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "MainInfo",
  props: ['tariff_packet_item'],
  data() {
    return {
      options: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
      tariff_active: true
    }
  },

  computed: {
    date_start() {
      return this.tariff_packet_item.ts_create > 0 ? this.get_date(this.tariff_packet_item.ts_create, this.options) : ''
    },
    date_update() {
      return this.tariff_packet_item.ts_update > 0 ? this.get_date(this.tariff_packet_item.ts_update, this.options) : ''
    },
    status_text() {
      return this.tariff_packet_item.tariffication.status > 0 ? 'Тарифицируется' : 'Не тарифицируется';
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

  }
}
</script>
<style lang="scss" scoped>
.tariff_packet_item_info {
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    text-align: center;

    .title {
      margin-top: 15px;
    }
  }
}

.content {
  .row {
    margin: 0;
    text-align: left;

    .area {
      margin-bottom: 10px;
    }
  }

  .filter.checkbox {
    min-width: auto;
    margin-top: 20px;
  }
}
</style>
